import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Link, Redirect, useHistory, useParams } from "react-router-dom";
import {
  FaCalendarAlt,
  FaCheckCircle,
  FaClipboardCheck,
  FaHome,
  FaHourglassHalf,
  FaSyncAlt,
  FaTimesCircle,
  FaUserClock,
  FaUsers,
} from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import AttendancePieChart from "../ChildComponent/AttendancePieChart ";
import BackButton from "../ChildComponent/BackButton";
import boyImage from "../img/boy.jpg";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

//Created By Cursor
function todayParts(date = new Date()) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const strMonth = month > 9 ? String(month) : `0${month}`;
  const strDay = day > 9 ? String(day) : `0${day}`;
  return {
    iso: `${year}-${strMonth}-${strDay}`,
    display: `${strDay}-${strMonth}-${year}`,
    month: strMonth,
    year,
  };
}

//Created By Cursor
function cleanParam(value) {
  const s = String(value ?? "").trim();
  if (!s || s === "null" || s === "undefined" || s === "No") return "";
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
}

//Created By Cursor
function applyDefaultMarks(list, presentAll) {
  return (Array.isArray(list) ? list : []).map((student) => ({
    ...student,
    attendence:
      student.OnLeave === "Yes" ? "L" : presentAll ? "P" : "A",
  }));
}

//Created By Cursor
function statusClass(mark) {
  if (mark === "P") return "tat-mark--p";
  if (mark === "A") return "tat-mark--a";
  if (mark === "L") return "tat-mark--l";
  return "";
}

//Created By Cursor
function KpiChip({ tone, icon: Icon, label, value }) {
  return (
    <div className={`sm-kpi-chip sm-kpi-chip--${tone}`}>
      <span className="sm-kpi-chip__icon" aria-hidden>
        {Icon ? <Icon /> : null}
      </span>
      <div className="sm-kpi-chip__text">
        <span className="sm-kpi-chip__label">{label}</span>
        <span className="sm-kpi-chip__value">{value}</span>
      </div>
    </div>
  );
}

//Created By Cursor
export default function TodayAttendance() {
  const history = useHistory();
  const params = useParams();
  const loggedIn = localStorage.getItem("token") != null;

  const classId = params.class_id;
  const sectionId = params.section_id;
  const className = cleanParam(params.class_name);
  const sectionName = cleanParam(params.section_name);
  const classLabel = sectionName ? `${className}:${sectionName}` : className;

  const dateInfo = useMemo(() => todayParts(), []);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [attendanceToday, setAttendanceToday] = useState(null);
  const [students, setStudents] = useState([]);
  const [presentAll, setPresentAll] = useState(true);
  /** Taken view: Present / Absent / Leave tabs (fetch only on tab click) */
  const [listTab, setListTab] = useState(null);
  const [takenStudents, setTakenStudents] = useState([]);
  const [takenListLoading, setTakenListLoading] = useState(false);
  const [takenListLoaded, setTakenListLoaded] = useState(false);

  const statusLabel = String(attendanceToday?.status || "").trim();
  const taken = /^taken$/i.test(statusLabel);
  //Created By Cursor — Sunday is takeable; only holidays remain blocked
  const dayBlocked = /^holiday$/i.test(statusLabel);
  const canTake = !taken && !dayBlocked && !!attendanceToday;

  const loadStudents = useCallback(
    async (presentAllFlag = presentAll) => {
      if (!classId || !sectionId) return;
      setLoading(true);
      try {
        const schoolCode = SessionManager.getSchoolCode();
        const reqParams = {
          school_code: schoolCode,
          class_id: classId,
          section_id: sectionId,
          date: dateInfo.iso,
        };
        const url = `${API_BASE()}getStudentByDate.php`;
        console.log("Full URL: ", `${url}?${new URLSearchParams(reqParams)}`);

        const response = await axios
          .get(url, { params: reqParams })
          .then((res) => res.data);

        if (response?.api_status === "OK") {
          const rows = Array.isArray(response.data) ? response.data : [];
          setStudents(applyDefaultMarks(rows, presentAllFlag));
        } else {
          setStudents([]);
          myToast.notify_warning(
            response?.api_remark || "No students found for today."
          );
        }
      } catch (error) {
        console.error(error);
        setStudents([]);
        myToast.notify_warning("Failed to load students.");
      } finally {
        setLoading(false);
      }
    },
    [classId, sectionId, dateInfo.iso, presentAll]
  );

  //Created By Cursor — one lean request for all marks; tabs filter locally
  const loadTakenStudents = useCallback(async () => {
    if (!classId || !sectionId) return;
    setTakenListLoading(true);
    try {
      const schoolCode = SessionManager.getSchoolCode();
      const reqParams = {
        school_code: schoolCode,
        class_id: classId,
        section_id: sectionId,
        date: dateInfo.iso,
      };
      const url = `${API_BASE()}getAttendanceStudentsLite.php`;
      console.log("Full URL: ", `${url}?${new URLSearchParams(reqParams)}`);

      const response = await axios
        .get(url, { params: reqParams })
        .then((res) => res.data);

      if (response?.api_status === "OK") {
        const rows = Array.isArray(response.data) ? response.data : [];
        setTakenStudents(rows);
        setTakenListLoaded(true);
      } else {
        setTakenStudents([]);
        setTakenListLoaded(true);
        myToast.notify_warning(
          response?.api_remark || "No attendance students found."
        );
      }
    } catch (error) {
      console.error(error);
      setTakenStudents([]);
      setTakenListLoaded(true);
      myToast.notify_warning("Failed to load attendance students.");
    } finally {
      setTakenListLoading(false);
    }
  }, [classId, sectionId, dateInfo.iso]);

  const loadAttendanceStatus = useCallback(async () => {
    if (!classId || !sectionId) return;
    setLoading(true);
    try {
      const schoolCode = SessionManager.getSchoolCode();
      if (!schoolCode) {
        myToast.notify_warning("Missing school code.");
        setAttendanceToday(null);
        setLoading(false);
        return;
      }
      const reqParams = {
        school_code: schoolCode,
        class_id: classId,
        section_id: sectionId,
        attendance_date: dateInfo.iso,
        month: dateInfo.month,
        year: String(dateInfo.year),
      };
      const url = `${API_BASE()}getParticularClassAttendanceToday.php`;
      console.log("Full URL: ", `${url}?${new URLSearchParams(reqParams)}`);

      const response = await axios
        .get(url, { params: reqParams })
        .then((res) => res.data);

      if (response?.api_status === "OK") {
        const row = Array.isArray(response.data)
          ? response.data[0]
          : response.data || null;
        const status = String(row?.status || "").trim();
        setAttendanceToday(row || null);

        if (/^taken$/i.test(status)) {
          setStudents([]);
          setTakenStudents([]);
          setTakenListLoaded(false);
          setListTab(null);
          setLoading(false);
          return;
        }

        //Created By Cursor — holidays still skip roster; Sunday loads students for marking
        if (/^holiday$/i.test(status)) {
          setStudents([]);
          setTakenStudents([]);
          setTakenListLoaded(false);
          setListTab(null);
          setLoading(false);
          return;
        }

        // Not Taken or Sunday — load class students next
        await loadStudents(presentAll);
        return;
      }

      setAttendanceToday(null);
      setStudents([]);
      myToast.notify_warning(
        response?.api_remark || "Failed to load attendance."
      );
      setLoading(false);
    } catch (error) {
      console.error(error);
      setAttendanceToday(null);
      setStudents([]);
      myToast.notify_warning("Failed to load attendance.");
      setLoading(false);
    }
  }, [
    classId,
    sectionId,
    dateInfo.iso,
    dateInfo.month,
    dateInfo.year,
    loadStudents,
    presentAll,
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadAttendanceStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classId, sectionId, dateInfo.iso]);

  //Created By Cursor — open a tab; fetch roster once on first click
  const onListTabClick = (key) => {
    setListTab(key);
    if (!takenListLoaded && !takenListLoading) {
      loadTakenStudents();
    }
  };

  const tabStudents = useMemo(() => {
    if (!listTab) return [];
    return takenStudents.filter(
      (s) => String(s.attendence || "").toUpperCase() === listTab
    );
  }, [takenStudents, listTab]);

  const liveCounts = useMemo(() => {
    let total;
    let present;
    let absent;
    let leave;
    if (taken && attendanceToday) {
      total = Number(attendanceToday.student_by_date_count || 0);
      present = Number(attendanceToday.P || 0);
      absent = Number(attendanceToday.A || 0);
      leave = Number(attendanceToday.L || 0);
    } else {
      total = students.length;
      present = students.filter((s) => s.attendence === "P").length;
      absent = students.filter((s) => s.attendence === "A").length;
      leave = students.filter((s) => s.attendence === "L").length;
    }
    const marked = present + absent + leave;
    const pending = Math.max(0, total - marked);
    const pct = (n) => (total === 0 ? 0 : Math.floor((n * 100) / total));
    return {
      total,
      present,
      absent,
      leave,
      pending,
      presentPct: pct(present),
      absentPct: pct(absent),
      leavePct: pct(leave),
      pendingPct: pct(pending),
      studentInClass: Number(attendanceToday?.student || total || 0),
      studentByDate: Number(
        attendanceToday?.student_by_date_count || total || 0
      ),
    };
  }, [taken, attendanceToday, students]);

  const onPresentAllChange = (checked) => {
    setPresentAll(checked);
    setStudents((prev) => applyDefaultMarks(prev, checked));
  };

  const isOnLeave = (student) =>
    String(student?.OnLeave || "").toLowerCase() === "yes";

  const setStudentMark = (enrollmentNo, mark) => {
    setStudents((prev) =>
      prev.map((student) => {
        if (student.student_enrollment_no !== enrollmentNo) return student;
        if (isOnLeave(student)) return student;
        return { ...student, attendence: mark };
      })
    );
  };

  const toggleStatus = (enrollmentNo) => {
    setStudents((prev) =>
      prev.map((student) => {
        if (student.student_enrollment_no !== enrollmentNo) return student;
        if (isOnLeave(student)) return student;
        const next =
          student.attendence === "P"
            ? "A"
            : student.attendence === "A"
            ? "L"
            : "P";
        return { ...student, attendence: next };
      })
    );
  };

  const submitAttendance = async () => {
    if (!students.length) {
      myToast.notify_warning("No students to submit.");
      return;
    }
    const staff = SessionManager.getStaffDetails();
    const staffId = staff?.staff_id;
    if (!staffId) {
      myToast.notify_warning("Missing staff details.");
      return;
    }

    setSaving(true);
    try {
      const schoolCode = SessionManager.getSchoolCode();
      const body = new URLSearchParams();
      body.append("class_id", classId);
      body.append("section_id", sectionId);
      body.append("date", dateInfo.iso);
      body.append("attendence", JSON.stringify(students));
      body.append("staff_id", staffId);
      body.append("school_code", schoolCode);

      const url = `${API_BASE()}addStudentAttendence.php`;
      console.log("Full URL: ", url);

      const response = await axios.post(url, body).then((res) => res.data);
      if (response?.api_status === "OK") {
        myToast.notify_success("Attendance submitted.");
        await loadAttendanceStatus();
      } else {
        myToast.notify_warning(response?.api_remark || "Submit failed.");
      }
    } catch (error) {
      console.error(error);
      myToast.notify_warning("Failed to submit attendance.");
    } finally {
      setSaving(false);
    }
  };

  const busy = loading || saving;

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div
      className="content payroll-page sm-page tat-page"
      style={{ fontFamily: PAGE_FONT, background: "#ffffff" }}
    >
      <div
        className="content-header d-flex justify-content-between align-items-center"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header d-flex align-items-center gap-2">
          <button
            type="button"
            className="qb-home-btn"
            aria-label="Home"
            onClick={() => history.push("/AdminMain")}
          >
            <FaHome />
          </button>
          <ul className="breadcrumbs mb-0">
            <li>
              <span style={{ color: COLORS.white }}>Attendance</span>
            </li>
            <li>
              <span style={{ color: COLORS.white }}>Today</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell tat-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaClipboardCheck />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Today Attendance</h1>
              <p className="sm-hero__sub">
                {classLabel || "Class"} · {dateInfo.display}
                {taken
                  ? " · Taken"
                  : dayBlocked
                  ? ` · ${statusLabel}`
                  : " · Not taken"}
              </p>
            </div>
          </div>
          <div className="sm-hero__tools">
            <Link to="/AdminMain/MonthAttendance" className="tat-hero-link">
              <FaCalendarAlt aria-hidden />
              <span>Month Attendance</span>
            </Link>
            <button
              type="button"
              className={`pp-icon-btn${loading ? " spinning" : ""}`}
              onClick={loadAttendanceStatus}
              disabled={busy}
              aria-label="Refresh"
              title="Refresh"
            >
              <FaSyncAlt aria-hidden />
            </button>
          </div>
        </header>

        <div className="tat-body">
          {loading && !students.length && !taken ? (
            <div className="tat-loading">
              <MyLoader />
            </div>
          ) : (
            <>
              <div className="tat-meta">
                <div className="tat-meta__class">
                  <span>Class</span>
                  <strong>{classLabel || "—"}</strong>
                </div>
                <div className="tat-meta__date">
                  <span>Date</span>
                  <strong>{dateInfo.display}</strong>
                </div>
                {canTake ? (
                  <label className="tat-present-all">
                    <span>Mark all present</span>
                    <input
                      type="checkbox"
                      checked={presentAll}
                      onChange={(e) => onPresentAllChange(e.target.checked)}
                      disabled={busy || !students.length}
                    />
                    <span className="tat-switch" aria-hidden />
                  </label>
                ) : null}
              </div>

              {!taken ? (
                <div className="sm-kpi-row tat-kpis" aria-label="Attendance totals">
                  <KpiChip
                    tone="sky"
                    icon={FaUserClock}
                    label="Total"
                    value={liveCounts.total}
                  />
                  <KpiChip
                    tone="mint"
                    icon={FaCheckCircle}
                    label="Present"
                    value={liveCounts.present}
                  />
                  <KpiChip
                    tone="sand"
                    icon={FaTimesCircle}
                    label="Absent"
                    value={liveCounts.absent}
                  />
                  <KpiChip
                    tone="blue"
                    icon={FaCalendarAlt}
                    label="Leave"
                    value={liveCounts.leave}
                  />
                </div>
              ) : null}

              {taken ? (
                <>
                <section className="mat-report-card tat-report">
                  <div className="mat-report-card__head">
                    <div className="mat-report-card__title">
                      <span className="mat-report-card__icon" aria-hidden>
                        <FaClipboardCheck />
                      </span>
                      <div>
                        <h2>Attendance report</h2>
                        <p>
                          Today · {dateInfo.display}
                          {classLabel ? ` · ${classLabel}` : ""}
                        </p>
                      </div>
                    </div>
                    <span className="mat-report-badge">Taken</span>
                  </div>

                  <div className="mat-report-body">
                    <div className="mat-report-chart">
                      <AttendancePieChart
                        Present={liveCounts.present}
                        Absent={liveCounts.absent}
                        Leave={liveCounts.leave}
                        size={180}
                        showLegend
                      />
                    </div>

                    <div className="mat-report-breakdown">
                      <div className="mat-report-bar is-p">
                        <div className="mat-report-bar__meta">
                          <span>
                            <FaCheckCircle aria-hidden /> Present
                          </span>
                          <strong>
                            {liveCounts.present}
                            <small>{liveCounts.presentPct}%</small>
                          </strong>
                        </div>
                        <div className="mat-report-bar__track" aria-hidden>
                          <i
                            style={{
                              width: `${Math.min(100, liveCounts.presentPct)}%`,
                            }}
                          />
                        </div>
                      </div>

                      <div className="mat-report-bar is-a">
                        <div className="mat-report-bar__meta">
                          <span>
                            <FaTimesCircle aria-hidden /> Absent
                          </span>
                          <strong>
                            {liveCounts.absent}
                            <small>{liveCounts.absentPct}%</small>
                          </strong>
                        </div>
                        <div className="mat-report-bar__track" aria-hidden>
                          <i
                            style={{
                              width: `${Math.min(100, liveCounts.absentPct)}%`,
                            }}
                          />
                        </div>
                      </div>

                      <div className="mat-report-bar is-l">
                        <div className="mat-report-bar__meta">
                          <span>
                            <FaCalendarAlt aria-hidden /> Leave
                          </span>
                          <strong>
                            {liveCounts.leave}
                            <small>{liveCounts.leavePct}%</small>
                          </strong>
                        </div>
                        <div className="mat-report-bar__track" aria-hidden>
                          <i
                            style={{
                              width: `${Math.min(100, liveCounts.leavePct)}%`,
                            }}
                          />
                        </div>
                      </div>

                      <div className="mat-report-bar is-pending">
                        <div className="mat-report-bar__meta">
                          <span>
                            <FaHourglassHalf aria-hidden /> Pending
                          </span>
                          <strong>
                            {liveCounts.pending}
                            <small>{liveCounts.pendingPct}%</small>
                          </strong>
                        </div>
                        <div className="mat-report-bar__track" aria-hidden>
                          <i
                            style={{
                              width: `${Math.min(100, liveCounts.pendingPct)}%`,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mat-report-foot">
                    <div className="mat-report-chip">
                      <span className="mat-report-chip__icon" aria-hidden>
                        <FaUsers />
                      </span>
                      <div>
                        <span>Students in class</span>
                        <strong>{liveCounts.studentInClass}</strong>
                      </div>
                    </div>
                    <div className="mat-report-chip">
                      <span className="mat-report-chip__icon is-sky" aria-hidden>
                        <FaUserClock />
                      </span>
                      <div>
                        <span>Recorded today</span>
                        <strong>{liveCounts.studentByDate}</strong>
                      </div>
                    </div>
                    <div className="mat-report-chip">
                      <span className="mat-report-chip__icon is-mint" aria-hidden>
                        <FaClipboardCheck />
                      </span>
                      <div>
                        <span>Month view</span>
                        <strong>
                          <Link
                            to="/AdminMain/MonthAttendance"
                            className="tat-report-link"
                          >
                            Open
                          </Link>
                        </strong>
                      </div>
                    </div>
                  </div>
                </section>

                <div
                  className="tat-tabs"
                  role="tablist"
                  aria-label="Students by attendance"
                >
                  {[
                    {
                      key: "P",
                      label: "Present Students",
                      short: "Present",
                      count: liveCounts.present,
                      tone: "p",
                      icon: FaCheckCircle,
                    },
                    {
                      key: "A",
                      label: "Absent Students",
                      short: "Absent",
                      count: liveCounts.absent,
                      tone: "a",
                      icon: FaTimesCircle,
                    },
                    {
                      key: "L",
                      label: "Leave",
                      short: "Leave",
                      count: liveCounts.leave,
                      tone: "l",
                      icon: FaCalendarAlt,
                    },
                  ].map((tab) => {
                    const Icon = tab.icon;
                    const active = listTab === tab.key;
                    return (
                      <button
                        key={tab.key}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        className={`tat-tabs__btn is-${tab.tone}${
                          active ? " is-active" : ""
                        }`}
                        onClick={() => onListTabClick(tab.key)}
                      >
                        <span className="tat-tabs__icon" aria-hidden>
                          <Icon />
                        </span>
                        <span className="tat-tabs__text">
                          <span className="tat-tabs__label">{tab.label}</span>
                          <span className="tat-tabs__short">{tab.short}</span>
                        </span>
                        <strong className="tat-tabs__count">{tab.count}</strong>
                      </button>
                    );
                  })}
                </div>

                {listTab ? (
                  takenListLoading || !takenListLoaded ? (
                    <div className="tat-loading">
                      <MyLoader />
                    </div>
                  ) : (
                  <section className="tat-list-card">
                    <div className="tat-list-card__head">
                      <h2 className="tat-list-card__title">
                        {listTab === "A"
                          ? "Absent Students"
                          : listTab === "L"
                          ? "Leave"
                          : "Present Students"}
                      </h2>
                      <span className="tat-list-card__count">
                        {tabStudents.length}
                      </span>
                    </div>
                    {tabStudents.length === 0 ? (
                      <div className="tat-empty">
                        No students in this list.
                      </div>
                    ) : (
                      <div className="tat-student-list" role="list">
                        {tabStudents.map((student, index) => {
                          const mark =
                            String(student.attendence || listTab).toUpperCase();
                          const name = student.stu_name || "—";
                          const initials = String(name)
                            .trim()
                            .split(/\s+/)
                            .slice(0, 2)
                            .map((p) => p[0] || "")
                            .join("")
                            .toUpperCase();
                          return (
                            <div
                              key={
                                student.student_enrollment_no ||
                                student.student_roll_no ||
                                `${name}-${index}`
                              }
                              role="listitem"
                              className={`tat-student tat-student--readonly ${statusClass(
                                mark
                              )}`}
                            >
                              <span className="tat-student__roll">
                                {student.student_roll_no || index + 1}
                              </span>
                              <div className="tat-student__main">
                                <span className="tat-student__avatar-wrap">
                                  <img
                                    className="tat-student__avatar"
                                    src={student.student_img_path || boyImage}
                                    alt=""
                                    onError={(e) => {
                                      e.currentTarget.style.display = "none";
                                      const fallback =
                                        e.currentTarget.nextElementSibling;
                                      if (fallback)
                                        fallback.style.display = "inline-flex";
                                    }}
                                  />
                                  <span
                                    className="tat-student__initials"
                                    style={{ display: "none" }}
                                    aria-hidden
                                  >
                                    {initials || "?"}
                                  </span>
                                </span>
                                <span className="tat-student__body">
                                  <strong>{name}</strong>
                                  <small>
                                    S/O {student.father_name || "—"}
                                  </small>
                                </span>
                              </div>
                              <div className="tat-student__actions">
                                <span
                                  className={`tat-mark-pill tat-mark-pill--status tat-mark-pill--${mark.toLowerCase()} is-active`}
                                >
                                  {mark === "A"
                                    ? "Absent"
                                    : mark === "L"
                                    ? "Leave"
                                    : "Present"}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </section>
                  )
                ) : null}
                </>
              ) : dayBlocked ? (
                <div className="tat-empty">
                  Today is a holiday — attendance is not required.
                </div>
              ) : canTake ? (
                <>
                  {students.length === 0 ? (
                    <div className="tat-empty">
                      {loading ? <MyLoader /> : "No students found for today."}
                    </div>
                  ) : (
                    <section className="tat-list-card">
                      <div className="tat-list-card__head">
                        <h2 className="tat-list-card__title">Students</h2>
                        <span className="tat-list-card__count">
                          {students.length}
                        </span>
                      </div>
                      <div className="tat-student-list" role="list">
                        {students.map((student, index) => {
                          const mark = student.attendence || "P";
                          const locked = isOnLeave(student);
                          const name = student.stu_name || "—";
                          const initials = String(name)
                            .trim()
                            .split(/\s+/)
                            .slice(0, 2)
                            .map((p) => p[0] || "")
                            .join("")
                            .toUpperCase();
                          return (
                            <div
                              key={
                                student.student_enrollment_no ||
                                student.student_roll_no ||
                                `${name}-${index}`
                              }
                              role="listitem"
                              className={`tat-student ${statusClass(mark)}${
                                locked ? " tat-student--locked" : ""
                              }`}
                            >
                              <span className="tat-student__roll">
                                {student.student_roll_no || index + 1}
                              </span>
                              <button
                                type="button"
                                className="tat-student__main"
                                onClick={() =>
                                  toggleStatus(student.student_enrollment_no)
                                }
                                disabled={busy || locked}
                                title={
                                  locked
                                    ? "Leave found — marked L"
                                    : "Tap to toggle Present / Absent / Leave"
                                }
                              >
                                <span className="tat-student__avatar-wrap">
                                  <img
                                    className="tat-student__avatar"
                                    src={student.student_img_path || boyImage}
                                    alt=""
                                    onError={(e) => {
                                      e.currentTarget.style.display = "none";
                                      const fallback =
                                        e.currentTarget.nextElementSibling;
                                      if (fallback)
                                        fallback.style.display = "inline-flex";
                                    }}
                                  />
                                  <span
                                    className="tat-student__initials"
                                    style={{ display: "none" }}
                                    aria-hidden
                                  >
                                    {initials || "?"}
                                  </span>
                                </span>
                                <span className="tat-student__body">
                                  <strong>{name}</strong>
                                  <small>
                                    S/O {student.father_name || "—"}
                                    {locked ? " · On leave" : ""}
                                  </small>
                                </span>
                              </button>
                              <div
                                className="tat-student__actions"
                                role="group"
                                aria-label={`Mark ${name}`}
                              >
                                {locked ? (
                                  <span className="tat-mark-pill tat-mark-pill--l is-active">
                                    L
                                  </span>
                                ) : (
                                  <>
                                    <button
                                      type="button"
                                      className={`tat-mark-pill tat-mark-pill--p${
                                        mark === "P" ? " is-active" : ""
                                      }`}
                                      disabled={busy}
                                      onClick={() =>
                                        setStudentMark(
                                          student.student_enrollment_no,
                                          "P"
                                        )
                                      }
                                    >
                                      P
                                    </button>
                                    <button
                                      type="button"
                                      className={`tat-mark-pill tat-mark-pill--a${
                                        mark === "A" ? " is-active" : ""
                                      }`}
                                      disabled={busy}
                                      onClick={() =>
                                        setStudentMark(
                                          student.student_enrollment_no,
                                          "A"
                                        )
                                      }
                                    >
                                      A
                                    </button>
                                    <button
                                      type="button"
                                      className={`tat-mark-pill tat-mark-pill--l${
                                        mark === "L" ? " is-active" : ""
                                      }`}
                                      disabled={busy}
                                      onClick={() =>
                                        setStudentMark(
                                          student.student_enrollment_no,
                                          "L"
                                        )
                                      }
                                    >
                                      L
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </section>
                  )}

                  <div className="tat-footer">
                    <div className="tat-footer__counts" aria-hidden>
                      <span className="is-p">Present {liveCounts.present}</span>
                      <span className="is-a">Absent {liveCounts.absent}</span>
                      <span className="is-l">Leave {liveCounts.leave}</span>
                    </div>
                    <button
                      type="button"
                      className="tat-btn tat-btn--primary"
                      onClick={submitAttendance}
                      disabled={busy || !students.length}
                    >
                      {saving ? "Submitting…" : "Submit Attendance"}
                    </button>
                  </div>
                </>
              ) : (
                <div className="tat-empty">
                  {loading
                    ? <MyLoader />
                    : "Unable to load today’s attendance status."}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
